module.exports = __webpack_public_path__ + "static/media/logo_komity_small.fd523f41.png";